export const membershipReferralInfoMessages = {
  totalReferralsLabel: 'Members Referred',
  referralCodeLabel: 'Referral Code',
};
